var map = {
	"./Centrifuga_Batelada.png": 73726,
	"./Centrifuga_Continua.png": 57105,
	"./ColunaDestilacaoA.png": 17157,
	"./Corn.png": 63945,
	"./DemandaEnergia.png": 97982,
	"./Desumidificador.png": 54611,
	"./FermentacaoBatelada.png": 99892,
	"./Filtro_Prensa.png": 30278,
	"./Regenerador_de_contato_direto.png": 55177,
	"./Tanque_Pulmao.png": 73714,
	"./Tanque_da_Volante.png": 70789,
	"./Tanque_de_condensado.png": 28160,
	"./Torre_de_Resfriamento.png": 62194,
	"./Turbo_bomba.png": 51559,
	"./Valvula.png": 11760,
	"./aquecedor.png": 70859,
	"./area1.png": 30468,
	"./area11.png": 26917,
	"./area12.png": 93005,
	"./area13.png": 35075,
	"./area14.png": 38684,
	"./area15.png": 62777,
	"./area16.png": 88719,
	"./area17.png": 61239,
	"./area1_difusor.png": 15432,
	"./area2.png": 95223,
	"./area3.png": 80812,
	"./area3_2.png": 47991,
	"./area4.png": 4981,
	"./area5.png": 63383,
	"./area6.png": 586,
	"./area7.png": 87514,
	"./area8.png": 49315,
	"./area9.png": 40340,
	"./area_3_nfc.png": 74308,
	"./area_4_pulp_wash.png": 79204,
	"./area_5_setor_core.png": 95739,
	"./area_6_racao.png": 24826,
	"./area_8_oleo_essencial.png": 52662,
	"./area_9_fabrica_celulas_.png": 73633,
	"./area_bos_milho.png": 59122,
	"./area_casca_seca.png": 81344,
	"./area_cozedor_liquefacao.png": 41838,
	"./area_ddgs.png": 18102,
	"./area_ddgs_milho.png": 74212,
	"./area_extratoras_citrus.png": 81972,
	"./area_fbp.png": 20708,
	"./area_fermentacao.png": 72508,
	"./area_lav_fab_celulas_citrus.png": 43694,
	"./area_wdg_milho.png": 38966,
	"./bomba.png": 71616,
	"./caixadetexto.png": 86566,
	"./caldeira.png": 63163,
	"./caleagem.png": 2351,
	"./cana.png": 31612,
	"./centrifuga_etanol.png": 79489,
	"./ciclone.png": 11103,
	"./citrus.png": 4396,
	"./citrus_centrifuga.png": 8197,
	"./citrus_evaporacao.png": 58636,
	"./citrus_extratora.png": 90218,
	"./citrus_fabrica_de_celulas.png": 70757,
	"./citrus_finisher.png": 91894,
	"./citrus_lavadora.png": 24687,
	"./clarifier_milho.png": 78238,
	"./colunaDestilacao2.png": 32986,
	"./colunaDestilacaoB.png": 68866,
	"./condensadorEvaporativo.png": 97992,
	"./cozedor.png": 44668,
	"./cozedor_milho.png": 95711,
	"./cristalizador.png": 98756,
	"./cuba.png": 5180,
	"./decantador.png": 83790,
	"./decanter_milho.png": 63005,
	"./desaerador.png": 8347,
	"./dessuperaquecedor.png": 60966,
	"./difusor.png": 72959,
	"./dorna_continua.png": 89733,
	"./evaporador.png": 37532,
	"./fabrica_de_celulas_2.png": 89938,
	"./filtro3.png": 29968,
	"./flash.png": 45943,
	"./flotador.png": 86926,
	"./lavador_de_gases.png": 36541,
	"./limpezaCana.png": 30178,
	"./liquefacao_milho.png": 22897,
	"./moinho_milho.png": 59102,
	"./mzsa_milho.png": 37896,
	"./ni.png": 3958,
	"./pasteurizador.png": 62621,
	"./peneira.png": 81395,
	"./perdadecarga.png": 22640,
	"./reator_combustao.png": 5696,
	"./refinaria.png": 61297,
	"./regenerador.png": 77920,
	"./secador.png": 68840,
	"./secador_ddgs_milho.png": 56890,
	"./sprayDryer.png": 83278,
	"./tanque.png": 73832,
	"./tanque_diluicao.png": 42437,
	"./tanque_mel.png": 68272,
	"./torreCO2.png": 64718,
	"./torreResfriamento.png": 58011,
	"./torre_sulfitacao.png": 95344,
	"./turbina.png": 62755,
	"./ultrafiltro.png": 27764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86077;